<template>
<ValidationObserver ref="observer">
  <form v-if="spj" ref="edit_spj_form" @submit.prevent="handleSubmit(updateSpj)">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Client Master
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="weekly" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Weekly Installment</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="spj.spj_weekly_installment" required/>
                  <validation-error :errors="apiValidationErrors.spj_weekly_installment" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="spj.spj_remarks" required/>
                  <validation-error :errors="apiValidationErrors.spj_remarks" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>
      </md-card-content> 
      

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('weekly', {
  ...required,
  message: 'Weekly Installment Field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    
    

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    props:{
      data_id:null
    },
    
   data: () => ({
     spj:null
    }),

    created() {
      this.getSpjData();
    },


     methods: {
       // ambil data yang dibutuhkan
    async getSpjData() { 
          console.log(this.data_id)
        //jika ada ambil data dari api
        await this.$store.dispatch("fms_spj_black_plate/get", this.data_id.id)
        this.spj = await this.$store.getters["fms_spj_black_plate/spj_black_plate"]
        
      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateSpj(id)
          }
        });
    },


    // fungsi edit
      async updateSpj(id) {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "error")
        //   return
        // }

        const data = {
          type: "fms_spj_black_plates",
          id: this.spj.id,
          spj_weekly_installment: this.spj.spj_weekly_installment,
          spj_remarks : this.spj.spj_remarks
        }

        try {
          //kirim data ke server
          await this.$store.dispatch("fms_spj_black_plate/update", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "SPJ data changed successfully.")
          //kembali ke list
         // await this.$router.replace({name: 'List Spj'});
          this.$parent.$parent.modalCloseEditSpj()
        } catch (e) {
          //panggil notifikasi error
          console.log(e)
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }



    // //fungsi yang ada di parent di panggil saat memilih row di table
    // onSelect (item) {
    //   this.$parent.$parent.$parent.$parent.modalCloseListDriver(item,this.item)
    //   },

      

     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>